import { render, staticRenderFns } from "./DemoTreeviewLoadChildren.vue?vue&type=template&id=3aee51a2&"
import script from "./DemoTreeviewLoadChildren.vue?vue&type=script&lang=js&"
export * from "./DemoTreeviewLoadChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VDivider,VIcon,VImg,VRow,VScrollYTransition,VTreeview})
